import { useCallback, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useListAccountMasterv2Query } from '../../../redux/apis/accountMaster.api';
import { defaultRowsPerPage } from '../../../utils/common';
import dayjs from 'dayjs';
import { API, graphqlOperation } from 'aws-amplify';
import { getAccountMasterName, listaccounttransactiondetailstotals, listAccountTransactionDetailsv3 } from '../../../graphql';
import { showWarningSnackbar } from '../../../components/snackBar/snakbar';
import { useFetchOpeningBalanceDateQuery } from '../../../redux/apis/openingbalacedate.api';

export const useTransactions = ({ accountId, startDate, endDate, includingOpeningBalance }) => {
  const { data: openingBalanceDate } = useFetchOpeningBalanceDateQuery(
    {
      invoicetypecd: 'Sales',
      invoiceid: 0,
    },
    {
      refetchOnMountOrArgChange: true,
    }
  );
  const openingBalanceDateString = openingBalanceDate?.getMinMaxInvoiceDate?.openingbalancedate;
  const parsedOpeningBalanceDate = openingBalanceDateString ? dayjs(openingBalanceDateString) : null;
  const openingBalanceSec = parsedOpeningBalanceDate?.isValid()
    ? parsedOpeningBalanceDate.startOf('day').unix()
    : null;

  // Use opening balance date as fyStart if available, otherwise use normal fyStart

  const userPrefrenceandFY = useSelector((state) => state.userPrefrenceandReducer);
  let { data: accountDetails, isLoading } = useListAccountMasterv2Query();
  const [rowsperpage, setrowsperpage] = useState(defaultRowsPerPage);
  const [page, setpage] = useState(0);
  const fstart = openingBalanceSec ? dayjs.unix(openingBalanceSec) : dayjs.unix(userPrefrenceandFY?.financialYear?.startdate);
  const fend = dayjs.unix(userPrefrenceandFY?.financialYear?.enddate);
  const defaultStartOfDay = fstart.startOf('day').unix();
  const defaultEndOfDay = fend.endOf('day').unix();
  const [includeOpening, setincludeOpening] = useState(includingOpeningBalance);
  const [showLinkedInvoiceVsReceipt, setShowLinkedInvoiceVsReceipt] = useState(false);
  // Use passed dates if not null, otherwise use defaults
  console.log({ startDate, defaultStartOfDay });
  const startOfDay = startDate || defaultStartOfDay;
  const endOfDay = endDate || defaultEndOfDay;
  const [filters, setfilters] = useState({
    custom: false,
    start: startOfDay,
    end: endOfDay,
    open: false,
    endRaw: '',
    startRaw: '',
  });
  const [data, setData] = useState({
    loading: true,
    rows: [],
    AccountName: '',
    AccountTypeFlag: 0,
    count: 0,
    loadingDetails: true,
    totalCredit: 0,
    totalDebit: 0,
    closingBalance: 0,
    balanceSign: 1,
  });
  const [transactionTotals, setTransactionTotals] = useState({
    credit: 0,
    debit: 0,
    closing: 0,
  });

  const getAccountName = useCallback(async () => {
    let response = await API.graphql(
      graphqlOperation(getAccountMasterName, {
        accountsid: accountId,
      })
    );
    setData((prev) => ({
      ...prev,
      AccountName: response.data.getAccountMaster?.accountname,
      AccountTypeFlag: response.data.getAccountMaster?.accounttypeflag,
    }));
    if (response.data.getAccountMaster?.accounttypeflag) {
      setShowLinkedInvoiceVsReceipt(true);
    }
  }, [accountId]);

  const fetchData = useCallback(
    async ({ start = filters.start, end = filters.end, limit, from = rowsperpage, reset }) => {
      try {
        if (reset) {
          setData((prev) => ({ ...prev, rows: [], loading: true }));
          setpage(0);
        } else {
          setData((prev) => ({ ...prev, loading: true }));
        }
        let response = API.graphql(
          graphqlOperation(listAccountTransactionDetailsv3, {
            accountid: accountId,
            startdate: start || filters.start,
            enddate: end || filters.end,
            limitno: from,
            rowfrom: limit ?? (data?.rows?.length || 0),
            searcharray: '[]',
            searchmode: 0,
            ordertype: 'asc',
            columnname: 'enteredtimestamp',
            // TODO: Backend is not ready to handle includingOpeningBalance parameter yet
            openingbalance: includeOpening ? 1 : 0,
          })
        );
        let responseOfCount = API.graphql(
          graphqlOperation(listaccounttransactiondetailstotals, {
            accountid: accountId,
            startdate: start || filters.start,
            enddate: end || filters.end,
            searcharray: '[]',
            searchmode: 0,
            openingbalance: includeOpening ? 1 : 0,
          })
        );

        {
          response = await response;
          let datas = response.data.listAccountTransactionDetailsv3;
          if (datas.length) {
            setData((prev) => ({
              ...prev,
              loading: false,
              rows: reset ? datas : [...prev.rows, ...datas],
            }));
            let reducedValue = datas.reduce(
              (acc, transaction) => {
                acc.debit += transaction.totaldebitamount;
                acc.credit += transaction.totalcreditamount;
                return acc;
              },
              { credit: 0, debit: 0 }
            );
            setTransactionTotals({
              ...reducedValue,
              closing: reducedValue.debit - reducedValue.credit,
            });
          } else {
            if (!includeOpening) {
              return;
            }
            // get account name if no transaction found

            const defaultOp = {
              accountgroupname: '',
              accountid: 3,
              accountname: '',
              accounttypecd: 'BS',
              balance: 0,
              comments: '',
              companyid: 312,
              crdrnoteid: 0,
              enteredtimestamp: userPrefrenceandFY?.financialYear?.startdate,
              entryordernumber: 2,
              financialyearid: 391,
              invoiceid: 0,
              oppositeaccountid: 12,
              oppositeaccountname: '',
              purchaseid: 0,
              totalcreditamount: 0,
              totaldebitamount: 0,
              transactionid: 1792,
              transactiontype: 'OpeningBalance',
              vouchernumber: '1792',
              vouchertype: 'OpeningBalance',
              __typename: 'TransactionDetailsv3',
            };
            setData((prev) => ({
              ...prev,
              loading: false,
              rows: [defaultOp],
            }));
          }
        }
        {
          responseOfCount = await responseOfCount;
          let data = responseOfCount.data.listaccounttransactiondetailstotals?.[0];
          console.log(data);
          setData((prev) => ({
            ...prev,
            count: data?.transactioncount,
            totalCredit: data?.totalcredit,
            totalDebit: data?.totaldebit,
            closingBalance: data?.closingbalance,
            balanceSign: data?.balancesign,
          }));
        }
      } catch (error) {
        console.log(error);
        setData((prev) => ({ ...prev, loading: false }));
        showWarningSnackbar('Something went wrong !');
      } finally {
        setData((prev) => ({ ...prev, loading: false }));
      }
    },
    [filters, accountId, data?.rows?.length, rowsperpage, userPrefrenceandFY?.financialYear?.startdate, startDate, endDate, includeOpening]
  );

  useEffect(() => {
    if (accountId && !(isNaN(accountId) || accountId === 0)) {
      getAccountName();
      fetchData({ start: filters.start, end: filters.end, limit: 0, from: rowsperpage, reset: true });
    } else if (!accountId) {
      setData((prev) => ({
        ...prev,
        loading: true,
        rows: [],
        AccountName: '',
      }));
      setfilters({
        custom: false,
        start: filters.start,
        end: filters.end,
        open: false,
        endRaw: '',
        startRaw: '',
      });
      setTransactionTotals({
        credit: 0,
        debit: 0,
        closing: 0,
      });
    }
    return () => {};
  }, [accountId, includeOpening]);

  const handleChangePage = useCallback(
    (event, newPage) => {
      if (data.loading) return;
      if (newPage > page) {
        if (data.rows.length !== data.count)
          if (data.rows.length < rowsperpage * (newPage + 1)) {
            fetchData({
              reset: false,
              from: rowsperpage,
              limit: Math.abs(rowsperpage * (newPage + 1) - rowsperpage + 1),
            });
          }
      }
      setpage(newPage);
    },
    [data, rowsperpage, page]
  );

  const handleChangeRowsPerPage = useCallback(
    (event) => {
      const newRowsPerPage = parseInt(event.target.value || 0, 10);
      const { loading, rows } = data;
      const length = rows?.length;
      console.log({ loading, length, newRowsPerPage, page });
      if (loading) return;
      setpage(0);
      setrowsperpage(newRowsPerPage);
      if (length < newRowsPerPage) {
        fetchData({
          from: newRowsPerPage,
          limit: length + 1,
        });
      }
      setpage(0);
    },
    [data]
  );

  const handleOpeningBalanceChange = () => setincludeOpening((prev) => !prev);
  const handleShowLinkedInvoiceVsReceiptChange = () => setShowLinkedInvoiceVsReceipt((prev) => !prev);
  return {
    handleChangePage,
    handleChangeRowsPerPage,
    data,
    openingBalanceSec,
    page,
    rowsperpage,
    transactionTotals,
    setfilters,
    filters,
    fetchData,
    isLoading,
    accountDetails,
    handleOpeningBalanceChange,
    includeOpening,
    showLinkedInvoiceVsReceipt,
    handleShowLinkedInvoiceVsReceiptChange,
  };
};
